import { Shield } from 'lucide-react';
import { ChangePasswordForm } from '../../../features/account-security/ChangePasswordForm';
import { cn } from '../../../utils/responsive';

interface SecuritySectionProps {
    isMobileOrTablet: boolean;
}

export function SecuritySection({ isMobileOrTablet }: SecuritySectionProps) {
    return (
        <div className={cn(
            "bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-stone-200 dark:border-gray-700 space-y-6",
            isMobileOrTablet ? "p-4" : "p-6"
        )}>
            <div className="space-y-2">
                <h2 className={cn(
                    "font-semibold text-stone-900 dark:text-gray-100 flex items-center gap-2",
                    isMobileOrTablet ? "text-base" : "text-lg"
                )}>
                    <Shield className={cn(
                        "text-yellow-600",
                        isMobileOrTablet ? "w-4 h-4" : "w-5 h-5"
                    )} />
                    เปลี่ยนรหัสผ่านผู้ดูแลระบบ
                </h2>
                <p className="text-sm text-stone-600 dark:text-gray-400">
                    ยืนยันรหัสผ่านปัจจุบันก่อนตั้งค่ารหัสผ่านใหม่ ระบบจะบังคับใช้ทันทีหลังบันทึกสำเร็จ
                </p>
            </div>
            <ChangePasswordForm />
        </div>
    );
}
